module.exports = __webpack_public_path__ + "static/media/017-patient.a8425523.svg";